import axios from 'axios';
import { useEffect, useState } from 'react';

import { useLazyGetAccessTokenQuery } from '@hook/consumer/consumer.hooks';
import { ConnectionInterface, ConnectionStateEnum } from '@interface/connection/connection.interface';
import { ConsumerInterface } from '@interface/consumer/consumer.interface';
import { isString } from '@util/data/is-exist';

export const ConsumerIntegration = ({ consumer }: { consumer: ConsumerInterface }) => {
  const [getAccessToken, { data }] = useLazyGetAccessTokenQuery();
  const [connections, setConnections] = useState<ConnectionInterface[]>([]);

  useEffect(() => void getAccessToken(consumer), [consumer.id]);

  useEffect(() => {
    if (!isString(data?.accessToken)) return;

    axios
      .get<{ data: ConnectionInterface[] }>(import.meta.env.VITE_API_SHARED_URL + '/connections', {
        headers: {
          authorization: `Bearer ${data?.accessToken}`,
        },
      })
      .then((response) =>
        setConnections(
          response.data.data
            .filter((connection) => connection.state === ConnectionStateEnum.Callable)
            .sort((a, b) => a.name.localeCompare(b.name)),
        ),
      );
  }, [data?.accessToken]);

  if (connections.length === 0) return <>List is empty</>;

  return <span>{connections.map((connection) => connection.name).join(', ')}</span>;
};
